export const sizeConfig = {
  screenSize: { width: 1920, height: 1080 },
  scale: 1,
};

export const customFont = "Pixellari, monospace";